
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Use a concurrent rendering mode for better performance
createRoot(document.getElementById("root")!).render(<App />);
